import { render, staticRenderFns } from "./PermissionsDepartment.vue?vue&type=template&id=70ecc057&scoped=true&"
import script from "./PermissionsDepartment.vue?vue&type=script&lang=js&"
export * from "./PermissionsDepartment.vue?vue&type=script&lang=js&"
import style0 from "./PermissionsDepartment.vue?vue&type=style&index=0&id=70ecc057&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ecc057",
  null
  
)

export default component.exports